import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import type { Profile } from '../../types';

export default function Profile() {
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({
    full_name: '',
    phone: '',
  });

  useEffect(() => {
    const fetchProfile = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', user.id)
          .single();
        setProfile(data);
        if (data) {
          setFormData({
            full_name: data.full_name,
            phone: data.phone || '',
          });
        }
      }
      setLoading(false);
    };
    fetchProfile();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!profile) return;

    const { error } = await supabase
      .from('profiles')
      .update({
        full_name: formData.full_name,
        phone: formData.phone,
        updated_at: new Date().toISOString(),
      })
      .eq('id', profile.id);

    if (!error) {
      setProfile(prev => prev ? { ...prev, ...formData } : null);
      setEditing(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-4 border-primary border-t-transparent mx-auto"></div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-white">Perfil</h1>

      <div className="card p-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center text-white text-2xl font-bold">
              {profile?.full_name?.charAt(0).toUpperCase() || 'U'}
            </div>
            <div>
              <h2 className="text-xl font-semibold text-white">{profile?.full_name}</h2>
              <p className="text-sm text-[#8E8E93]">{profile?.email}</p>
            </div>
          </div>
          <button onClick={() => setEditing(!editing)} className="text-primary">
            {editing ? 'Cancelar' : 'Editar'}
          </button>
        </div>

        {editing ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[#E5E5EA] mb-1">Nombre completo</label>
              <input
                type="text"
                value={formData.full_name}
                onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
                className="input"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[#E5E5EA] mb-1">Teléfono</label>
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                className="input"
              />
            </div>
            <button type="submit" className="btn-primary w-full">
              Guardar cambios
            </button>
          </form>
        ) : (
          <div className="space-y-3">
            <div className="flex justify-between py-2 border-b">
              <span className="text-[#8E8E93]">Nombre</span>
              <span className="text-white">{profile?.full_name}</span>
            </div>
            <div className="flex justify-between py-2 border-b">
              <span className="text-[#8E8E93]">Email</span>
              <span className="text-white">{profile?.email}</span>
            </div>
            <div className="flex justify-between py-2 border-b">
              <span className="text-[#8E8E93]">Teléfono</span>
              <span className="text-white">{profile?.phone || 'No registrado'}</span>
            </div>
            <div className="flex justify-between py-2">
              <span className="text-[#8E8E93]">Rol</span>
              <span className="text-primary capitalize">{profile?.role}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
